<template>
<div class="containers">
    <CRow v-if="goArea == '1'" class="p-4" style="background-color:rgba(249, 250, 252, 1)">
        <CCol sm="4 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Pegawai</div>
                    <div class="card-subtitle">Total data pegawai aktif</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalData}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Data</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="4 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Data Gaji Terdaftar</div>
                    <div class="card-subtitle">Data gaji pegawai yang sudah terdaftar</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalGenerate}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Data</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="4 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Data Gaji Belum Terdaftar</div>
                    <div class="card-subtitle">Data gaji pegawai yang belum terdaftar</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalBelumGenerate}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Data</span>
                    </div>
                </div>
            </div>
        </CCol>
    </CRow>
    <div v-if="goArea == '1'" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="10">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4">
                    <CButton color="primary" @click="goArea = '3'" class="mr-3" variant='outline'>Import Master Gaji</CButton>
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="addData()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" @view="viewData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="detailModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail Master Gaji</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="detailModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            : <span class="font-weight-bold">{{viewNama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            : {{viewNik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Tanggal Aktif
                        </CCol>
                        <CCol sm="9">
                            : {{separatorTanggal(viewTglAktif)}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Tanggal Non Aktif
                        </CCol>
                        <CCol sm="9">
                            : {{separatorTanggal(viewTglNonAktif)}}
                        </CCol>
                    </CRow>
                    <hr />
                    <CRow>
                        <CCol sm="6">
                            <CRow>
                                <CCol sm="12 mb-2">
                                    <span class="font-weight-bold">Penghasilan Tetap</span>
                                </CCol>
                            </CRow>
                            <CRow v-for="(temp1, id1) in viewDetailPenghasilanTetap" :key="id1" class="mt-1">
                                <CCol sm="6">
                                    {{temp1.keterangan}} ({{separatorInterval(temp1.interval)}})
                                </CCol>
                                <CCol class="text-right" v-if="temp1.satuan == 'N'" sm="6">
                                    Rp. {{separatorRupiah(temp1.nominal)}}
                                </CCol>
                                <CCol class="text-right" v-else sm="6">
                                    {{temp1.nominal}}%
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="6">
                            <CRow>
                                <CCol sm="12 ">
                                    <span class="font-weight-bold">Penghasilan Tidak Tetap</span>
                                </CCol>
                            </CRow>
                            <CRow v-for="(temp2, id2) in viewDetailPenghasilanTidakTetap" :key="id2" class="mt-1">
                                <CCol sm="6">
                                    {{temp2.keterangan}} ({{separatorInterval(temp2.interval)}})
                                </CCol>
                                <CCol class="text-right" v-if="temp2.satuan == 'N'" sm="6">
                                    Rp. {{separatorRupiah(temp2.nominal)}}
                                </CCol>
                                <CCol class="text-right" v-else sm="6">
                                    {{temp2.nominal}}%
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <hr v-if="viewDetailDitanggungPerusahaan.length != 0 || viewDetailDitanggungPegawai.length != 0" class="mt-2" />
                    <CRow>
                        <CCol sm="6">
                            <CRow>
                                <CCol sm="12 ">
                                    <span class="font-weight-bold">Potongan Ditanggung Perusahaan</span>
                                </CCol>
                            </CRow>
                            <CRow v-for="(temp3, id3) in viewDetailDitanggungPerusahaan" :key="id3" class="mt-1">
                                <CCol sm="6">
                                    {{temp3.keterangan}} ({{separatorInterval(temp3.interval)}})
                                </CCol>
                                <CCol class="text-right" v-if="temp3.satuan == 'N'" sm="6">
                                    Rp. {{separatorRupiah(temp3.nominal)}}
                                </CCol>
                                <CCol class="text-right" v-else sm="6">
                                    {{temp3.nominal}}%
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="6">
                            <CRow>
                                <CCol sm="12 ">
                                    <span class="font-weight-bold">Potongan Ditanggung Pegawai</span>
                                </CCol>
                            </CRow>
                            <CRow v-for="(temp4, id4) in viewDetailDitanggungPegawai" :key="id4" class="mt-1">
                                <CCol sm="6">
                                    {{temp4.keterangan}} ({{separatorInterval(temp4.interval)}})
                                </CCol>
                                <CCol class="text-right" v-if="temp4.satuan == 'N'" sm="6">
                                    Rp. {{separatorRupiah(temp4.nominal)}}
                                </CCol>
                                <CCol class="text-right" v-else sm="6">
                                    {{temp4.nominal}}%
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="12">
                        <CButton @click="detailModal = false" style="float:right" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
    <div v-if="goArea == '2'" class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow v-if="tipe == 'U'" class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <input 
                            disabled
                            style="background-color:whitesmoke"
                            class="form-control" 
                            v-model="editNama"
                            placeholder="Nama Pegawai" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>NIP</label>
                        <input 
                            disabled
                            class="form-control" 
                            style="background-color:whitesmoke"
                            v-model="editNik"
                            placeholder="NIP" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tanggal Aktif</label>
                        <input 
                            disabled
                            style="background-color:whitesmoke"
                            class="form-control" 
                            v-model="editTglAktif"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Non Aktif</label>
                        <input 
                            disabled
                            class="form-control" 
                            style="background-color:whitesmoke"
                            v-model="editTglNonAktif"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <hr v-if="editDetailPenghasilanTetap.length != 0"/>
                <CRow v-if="editDetailPenghasilanTetap.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Penghasilan Tetap</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data1, id1) in editDetailPenghasilanTetap" :key="id1" sm="6">
                                <label>{{data1.keterangan}} / {{separatorInterval(data1.interval)}} ({{separatorSatuan(data1.satuan)}})</label>
                                <input 
                                    v-if="data1.satuan == 'N'"
                                    class="form-control"
                                    @input="rupiahModeUangSaku('penghasilanTetap', id1)"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    v-model="data1.nominal"
                                    :placeholder="data1.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data1.nominal"
                                    :placeholder="data1.keterangan"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="editDetailPenghasilanTidakTetap.length != 0"/>
                <CRow v-if="editDetailPenghasilanTidakTetap.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Penghasilan Tidak Tetap</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data2, id2) in editDetailPenghasilanTidakTetap" :key="id2" sm="6">
                                <label>{{data2.keterangan}} / {{separatorInterval(data2.interval)}} ({{separatorSatuan(data2.satuan)}})</label>
                                <input 
                                    v-if="data2.satuan == 'N'"
                                    @input="rupiahModeUangSaku('penghasilanTidakTetap', id2)"
                                    class="form-control"
                                    v-model="data2.nominal"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    :placeholder="data2.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data2.nominal"
                                    :placeholder="data2.keterangan" 
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="editDetailDitanggungPerusahaan.length != 0"/>
                <CRow v-if="editDetailDitanggungPerusahaan.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Potongan Ditanggung Perusahaan</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data3, id3) in editDetailDitanggungPerusahaan" :key="id3" sm="6">
                                <label>{{data3.keterangan}} / {{separatorInterval(data3.interval)}} ({{separatorSatuan(data3.satuan)}})</label>
                                <input 
                                    v-if="data3.satuan == 'N'"
                                    @input="rupiahModeUangSaku('penguranganDitanggungPerusahaan', id3)"
                                    class="form-control"
                                    v-model="data3.nominal"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    :placeholder="data3.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data3.nominal"
                                    :placeholder="data3.keterangan" 
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="editDetailDitanggungPegawai.length != 0"/>
                <CRow v-if="editDetailDitanggungPegawai.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Potongan Ditanggung Pegawai</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data4, id4) in editDetailDitanggungPegawai" :key="id4" sm="6">
                                <label>{{data4.keterangan}} / {{separatorInterval(data4.interval)}} ({{separatorSatuan(data4.satuan)}})</label>
                                <input 
                                    v-if="data4.satuan == 'N'"
                                    @input="rupiahModeUangSaku('penguranganDitanggungPegawai', id4)"
                                    class="form-control"
                                    v-model="data4.nominal"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    :placeholder="data4.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data4.nominal"
                                    :placeholder="data4.keterangan" 
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow v-if="tipe == 'C'" class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisiblePegawaiAdd()"
                                    @blur="toggleCloseVisiblePegawaiAdd()"
                                    :class="{ 'is-invalid':$v.queryPegawaiAdd.$error, 'is-valid': !$v.queryPegawaiAdd.$invalid }"
                                    v-model.trim="$v.queryPegawaiAdd.$model"
                                    v-text="selectedItemPegawaiAdd ? selectedItemPegawaiAdd['text'] : ''"
                                    @keydown.up="upPegawaiAdd"
                                    @keydown.down="downPegawaiAdd"
                                    @keydown.enter="selectItemPegawaiAdd"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visiblePegawaiAdd">
                                <div class="options" v-if="matchesPegawaiAdd.length != 0 && queryPegawaiAdd.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPegawaiAdd"
                                        :key="index"
                                        :class="{ 'selected': (selectedPegawaiAdd == index)}"
                                        @click="itemClickedPegawaiAdd(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPegawaiAdd.length == 0 && queryPegawaiAdd.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPegawaiAdd.length == 0 && queryPegawaiAdd.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <hr v-if="addDetailPenghasilanTetap.length != 0"/>
                <CRow v-if="addDetailPenghasilanTetap.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Penghasilan Tetap</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data1, id1) in addDetailPenghasilanTetap" :key="id1" sm="6">
                                <label>{{data1.keterangan}} / {{separatorIntervalAdd(data1.interval)}} ({{separatorSatuanAdd(data1.satuan)}})</label>
                                <input 
                                    v-if="data1.satuan == 'N'"
                                    class="form-control"
                                    @input="rupiahModeUangSakuAdd('penghasilanTetap', id1)"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    v-model="data1.nominal"
                                    :placeholder="data1.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data1.nominal"
                                    :placeholder="data1.keterangan"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="addDetailPenghasilanTidakTetap.length != 0"/>
                <CRow v-if="addDetailPenghasilanTidakTetap.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Penghasilan Tidak Tetap</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data2, id2) in addDetailPenghasilanTidakTetap" :key="id2" sm="6">
                                <label>{{data2.keterangan}} / {{separatorIntervalAdd(data2.interval)}} ({{separatorSatuanAdd(data2.satuan)}})</label>
                                <input 
                                    v-if="data2.satuan == 'N'"
                                    @input="rupiahModeUangSakuAdd('penghasilanTidakTetap', id2)"
                                    class="form-control"
                                    v-model="data2.nominal"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    :placeholder="data2.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data2.nominal"
                                    :placeholder="data2.keterangan" 
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="addDetailDitanggungPerusahaan.length != 0"/>
                <CRow v-if="addDetailDitanggungPerusahaan.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Potongan Ditanggung Perusahaan</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data3, id3) in addDetailDitanggungPerusahaan" :key="id3" sm="6">
                                <label>{{data3.keterangan}} / {{separatorIntervalAdd(data3.interval)}} ({{separatorSatuanAdd(data3.satuan)}})</label>
                                <input 
                                    v-if="data3.satuan == 'N'"
                                    @input="rupiahModeUangSakuAdd('penguranganDitanggungPerusahaan', id3)"
                                    class="form-control"
                                    v-model="data3.nominal"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    :placeholder="data3.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data3.nominal"
                                    :placeholder="data3.keterangan" 
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="addDetailDitanggungPegawai.length != 0"/>
                <CRow v-if="addDetailDitanggungPegawai.length != 0">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="12">
                                <span class="font-weight-bold">Potongan Ditanggung Pegawai</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol v-for="(data4, id4) in addDetailDitanggungPegawai" :key="id4" sm="6">
                                <label>{{data4.keterangan}} / {{separatorIntervalAdd(data4.interval)}} ({{separatorSatuanAdd(data4.satuan)}})</label>
                                <input 
                                    v-if="data4.satuan == 'N'"
                                    @input="rupiahModeUangSakuAdd('penguranganDitanggungPegawai', id4)"
                                    class="form-control"
                                    v-model="data4.nominal"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                                    :placeholder="data4.keterangan" 
                                    type="text"
                                />
                                <input 
                                    v-else
                                    class="form-control"
                                    v-model="data4.nominal"
                                    :placeholder="data4.keterangan" 
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode == 46)" 
                                    type="text"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" style="float:left" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
    <div v-if="goArea == '3'" class="area-edit">
        <CAlert
        v-if="successImport == true"
        :show.sync="currentAlertCounterImport"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMessImport}}
        </CAlert>
        <CAlert 
        v-else
        :show.sync="currentAlertCounterImport"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMessImport}}
        </CAlert>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="goArea = '1', dataImport = [], infoImport = '', jumlahInvalid = '', jumlahValid = ''" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Unduh Template Excel Master Gaji</label>
                        <div>
                            <CButton style="width:200px" @click="getDownloadTemplate()" color="primary" variant='outline'><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'download'}" />Export Template Gaji</CButton>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Import Master Gaji (.xls)</label>
                        <div>
                            <CButton style="width:200px" color="primary" onclick="document.getElementById('inputFile').click()" variant='outline'>
                                <span v-if="loadingUpload == false"><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'upload'}" />Import Excel</span>
                                <CSpinner v-else color="default" size="sm"/>
                            </CButton>
                            <input type="file" @change="loadFile()" style="display:none" accept=".xls, .xlsx" id="inputFile" class="hide" />
                        </div>
                    </CCol>
                </CRow>
                <CRow class="mt-4">
                    <CRow v-if="dataImport != [] && dataImport.data != undefined">
                        <CCol sm="4">
                            Nama File
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold font-italic">{{infoImport}}</span>
                        </CCol>
                        <CCol sm="4">
                            Total data
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{dataImport.data.length}} Data</span>
                        </CCol>
                        <CCol sm="4">
                            Total data yang sukses
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{jumlahValid}} Data</span>
                        </CCol>
                        <CCol sm="4">
                            Total data yang tidak ditemukan
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{jumlahInvalid}} Data</span>
                        </CCol>
                        <CCol sm="4">
                            Export Result Review
                        </CCol>
                        <CCol sm="8">
                            : <img @click="getDownloadReview()" style="cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                    <div v-if="dataImport != ''" class="mt-1" style="overflow-x:auto;">
                        <table>
                            <thead>
                                <tr>
                                    <th v-for="(head, id) in dataImport.kolom" :key="id">{{head}}</th>
                                </tr>
                            </thead>
                            <tbody v-if="dataImport.data.length != 0">
                                <tr v-for="(row, ids) in dataImport.data" :key="ids">
                                    <td v-for="(col, index) in row" :key="index">{{col}}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr >
                                    <td class="text-center" :colspan="dataImport.kolom.length">Maaf, Data Excel Kosong</td>
                                </tr>
                            </tbody>     
                        </table>
                    </div>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit" v-if="dataImport != [] && dataImport.data != undefined">
            <CCol sm="12">
                <CButton @click="goArea = '1', dataImport = [], infoImport = '', jumlahInvalid = '', jumlahValid = ''" type="button" style="float:left" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="dataImport.data.length != 0" @click="sumbitImport()" class="btn btn-edit-submit">
                    <span v-if="loadingImport == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableGaji'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    components: {
        ModelSelect,
        Tables,
    },
    mixins: [validationMixin],
    validations: {
        queryPegawaiAdd: {
            required
        },
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            // add data search pegawai
            dataPegawaiAdd: [],
            titlePegawaiAdd:"Pilih Pegawai",
            selectedItemPegawaiAdd: null,
            selectedPegawaiAdd: 0,
            queryPegawaiAdd: '',
            visiblePegawaiAdd: false,
            idPegawaiAdd: '',

            success: true,
            successImport: false,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama / NIP', 'Tanggal Aktif', 'Tanggal Non Aktif', 'Action'],
            dataTd: [['nama', 'nik'], 'tglAktif', 'tglNonAktif', 'actions'],
            styleTable: ['200px', '100px', '100px', '100px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: '1',
            loading: false,
            loadingImport: false,
            loadingUpload: false,
            currentAlertCounter: 0,
            currentAlertCounterImport: 0,

            // data model
            tipe: 'C',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            totalData: 0,
            totalGenerate: 0,
            totalBelumGenerate: 0,

            // add
            addDetailPenghasilanTetap: '',
            addDetailPenghasilanTidakTetap: '',
            addDetailDitanggungPerusahaan: '',
            addDetailDitanggungPegawai: '',

            // data
            editNama: '',
            editNik: '',
            editDetailPenghasilanTetap: '',
            editDetailPenghasilanTidakTetap: '',
            editDetailDitanggungPerusahaan: '',
            editDetailDitanggungPegawai: '',
            editUnix: '',
            editIdPeg: '',
            editTglAktif: '',
            editTglNonAktif: '',


            // view
            detailModal: false,
            viewNama: '',
            viewNik: '',
            viewTglNonAktif: '',
            viewTglAktif: '',
            viewDetailPenghasilanTetap: '',
            viewDetailPenghasilanTidakTetap: '',
            viewDetailDitanggungPerusahaan: '',
            viewDetailDitanggungPegawai: '',
            viewUnix: '',
            viewIdPeg: '',
            viewHkp: '',

            // import
            infoImport: '',
            dataImport: '',
            errImport: '',
            jumlahInvalid: '',
            jumlahValid: '',

            // error
            errorMessage: '',
        }
    },
    watch: {
        page() {
            this.getData()
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            this.page = 1
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.getDataPegawai()
        },
        queryPegawaiAdd() {
            if(this.queryPegawaiAdd == '') {
                this.idPegawaiAdd = ''
            }
            this.getDataPegawaiAdd()
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        detailModal() {
            if(this.detailModal == false) {
                this.viewNama = ''
                this.viewNik = ''
                this.viewTglAktif = ''
                this.viewTglNonAktif = ''
                this.viewDetailPenghasilanTetap = '',
                this.viewDetailPenghasilanTidakTetap = '',
                this.viewDetailDitanggungPerusahaan = '',
                this.viewDetailDitanggungPegawai = '',
                this.viewUnix = ''
                this.viewIdPeg = ''
            }
        },
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesPegawaiAdd() {
            if (this.queryPegawaiAdd == '') {
                return [];
            }
            return this.dataPegawaiAdd.filter((item) => item['text'].toLowerCase().includes(this.queryPegawaiAdd.toLowerCase()))
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        /**
         * SEARCH PEGAWAI
         */
        getDataPegawaiAdd() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawaiAdd,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawaiAdd = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawaiAdd.push(onPush)
                }
            })
        },
        toggleVisiblePegawaiAdd() {
            this.visiblePegawaiAdd = true;
        },
        hidePegawaiAdd() {
            this.visiblePegawaiAdd = false;
        },
        toggleCloseVisiblePegawaiAdd() {
            setTimeout(this.hidePegawaiAdd, 1000);
        },
        itemClickedPegawaiAdd(index) {
            this.selectedPegawaiAdd = index;
            this.selectItemPegawaiAdd();
        },
        selectItemPegawaiAdd() {
            if (!this.matchesPegawaiAdd.length) {
            return;
            }
            this.selectedItemPegawaiAdd = this.matchesPegawaiAdd[this.selectedPegawaiAdd];
            this.visiblePegawaiAdd = false;
            this.queryPegawaiAdd = this.selectedItemPegawaiAdd.text
            this.idPegawaiAdd = this.selectedItemPegawaiAdd.value
            if (this.shouldReset) {
            this.queryPegawaiAdd = '';
            this.selectedPegawaiAdd = 0;
            }
        },
        upPegawaiAdd() {
            if (this.selectedPegawaiAdd == 0) {
            return;
            }
            this.selectedPegawaiAdd -= 1;
            this.scrollToItemPegawaiAdd();
        },
        downPegawaiAdd() {
            if (this.selectedPegawaiAdd >= this.matchesPegawaiAdd.length - 1) {
            return;
            }
            this.selectedPegawaiAdd += 1;
            this.scrollToItemPegawaiAdd();
        },
        scrollToItemPegawaiAdd() {
            this.$refs.optionsList.scrollTop = this.selectedPegawaiAdd * this.itemHeight;
        },
        
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownloadTemplate() {
            let payload = {}
            DataApi.post("/export/salary/import/template", payload, {responseType: 'blob'})
            .then(res => {
                let response = res.data
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/vnd.ms-excel'
                }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Template Master Gaji')
                document.body.appendChild(link)
                link.click()
            })
        },
        getDownload() {
            if(this.datas.length != 0) {
                let nama = ''
                let idPegawai = ''
                if(this.idPegawai == '') {
                    nama = this.queryPegawai
                    idPegawai = ''
                } else {
                    nama = ''
                    idPegawai = this.idPegawai
                }
                let payload = {
                    idPegawai: idPegawai,
                    limit: this.size,
                    nama: nama,
                    pageIn: this.page
                }
                DataApi.post("/export/salary/lihat", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Master Gaji')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        getDownloadReview() {
            let payload = {
                jumlahInvalid: this.jumlahInvalid,
                jumlahValid: this.jumlahValid,
                kolom: this.dataImport.kolom,
                data: this.dataImport.data,
            }
            DataApi.post("/export/salary/transaksi/priview/import", payload, {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Import Review Master Gaji')
                    document.body.appendChild(link)
                    link.click()
                })
        },
        getData() {
            this.$store.state.loadingScreen = true
            let nama = ''
            let idPegawai = ''
            if(this.idPegawai == '') {
                nama = this.queryPegawai
                idPegawai = ''
            } else {
                nama = ''
                idPegawai = this.idPegawai
            }
            let payload = {
                idPegawai: idPegawai,
                limit: this.size,
                nama: nama,
                pageIn: this.page
            }
            DataApi.post("salary/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalData = response.data.totalPegawai
                    this.totalGenerate = response.data.totalRow
                    this.totalBelumGenerate = this.totalData - this.totalGenerate
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.totalPage = 1
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalData = 0
                    this.totalGenerate = 0
                    this.totalBelumGenerate = 0
                    this.page = 1
                    this.errorMessage = response.message
                }
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.page = 1
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        addData() {
            DataApi.get("salary/aktif")
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.addDetailPenghasilanTetap = response.data.daftarPenghasilanTetap
                    this.addDetailPenghasilanTidakTetap = response.data.daftarPenghasilanTidakTetap
                    this.addDetailDitanggungPerusahaan = response.data.daftarDitanggungPerusahaan
                    this.addDetailDitanggungPegawai = response.data.daftarDitanggungPegawai
                    this.goArea = '2' 
                    this.tipe = 'C'
                }
            })
        },
        moving() {
            setTimeout(this.moveArea, 100);
        },
        moveArea() {
            if(this.goArea == '1') {
                this.goArea = '2'
            } else {
                this.goArea = '1'
                this.queryPegawaiAdd = ''
                this.idPegawaiAdd = ''
                this.$v.$reset()
            }
        },
        goSave(vals) {
            let arry = ['0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0']
            let data = ''
            let data2 = ''
            let data3 = ''
            let data4 = ''
            let unix = ''
            let idPeg = ''
            if(vals == 'U') {
                data = this.editDetailPenghasilanTetap
                data2 = this.editDetailPenghasilanTidakTetap
                data3 = this.editDetailDitanggungPerusahaan
                data4 = this.editDetailDitanggungPegawai
                unix = this.editUnix
                idPeg = this.editIdPeg
            } else {
                data = this.addDetailPenghasilanTetap
                data2 = this.addDetailPenghasilanTidakTetap
                data3 = this.addDetailDitanggungPerusahaan
                data4 = this.addDetailDitanggungPegawai
                unix = ''
                idPeg = this.idPegawaiAdd
            }

            
            
            var i,j,k,l = 0
            for(i=0;i<data.length;i++) {
                arry[parseInt(data[i].attribute)] = ''
                if(data[i].nominal == '0' && data[i].nominalHitung == '0') {
                    arry[parseInt(data[i].attribute)] = '0'
                } else {
                    let clear = ''
                    if(data[i].satuan == 'N') {
                        clear = data[i].nominal.replace("Rp. ", '')
                        var o = 0
                        for(o=0;o<clear.length;o++) {
                            if(clear[o] == '.') {
                                //  
                            } else {
                                arry[parseInt(data[i].attribute)] += clear[o]
                            }
                        }
                    } else {
                        arry[parseInt(data[i].attribute)] = data[i].nominal
                    }
                }
            }

            for(j=0;j<data2.length;j++) {
                arry[parseInt(data2[j].attribute)] = ''
                if(data2[j].nominal == '0' && data2[j].nominalHitung == '0') {
                    arry[parseInt(data2[j].attribute)] = '0'
                } else {
                    let clear = ''
                    if(data2[j].satuan == 'N') {
                        clear = data2[j].nominal.replace("Rp. ", '')
                        var m = 0
                        for(m=0;m<clear.length;m++) {
                            if(clear[m] == '.') {
                                //
                            } else {
                                arry[parseInt(data2[j].attribute)] += clear[m]
                            }
                        }
                    } else {
                        arry[parseInt(data2[j].attribute)] = data2[j].nominal
                    }
                }
            }

            for(k=0;k<data3.length;k++) {
                arry[parseInt(data3[k].attribute)] = ''
                if(data3[k].nominal == '0' && data3[k].nominalHitung == '0') {
                    arry[parseInt(data3[k].attribute)] = '0'
                } else {
                    let clear = ''
                    if(data3[k].satuan == 'N') {
                        clear = data3[k].nominal.replace("Rp. ", '')
                        var m = 0
                        for(m=0;m<clear.length;m++) {
                            if(clear[m] == '.') {
                                //
                            } else {
                                arry[parseInt(data3[k].attribute)] += clear[m]
                            }
                        }
                    } else {
                        arry[parseInt(data3[k].attribute)] = data3[k].nominal
                    }
                }
            }

            for(l=0;l<data4.length;l++) {
                arry[parseInt(data4[l].attribute)] = ''
                if(data4[l].nominal == '0' && data4[l].nominalHitung == '0') {
                    arry[parseInt(data4[l].attribute)] = '0'
                } else {
                    let clear = ''
                    if(data4[l].satuan == 'N') {
                        clear = data4[l].nominal.replace("Rp. ", '')
                        var m = 0
                        for(m=0;m<clear.length;m++) {
                            if(clear[m] == '.') {
                                //
                            } else {
                                arry[parseInt(data4[l].attribute)] += clear[m]
                            }
                        }
                    } else {
                        arry[parseInt(data4[l].attribute)] = data4[l].nominal
                    }
                }
            }

            let payload = {
                attribute_10: arry[10],
                attribute_11: arry[11],
                attribute_12: arry[12],
                attribute_13: arry[13],
                attribute_14: arry[14],
                attribute_15: arry[15],
                attribute_16: arry[16],
                attribute_17: arry[17],
                attribute_18: arry[18],
                attribute_19: arry[19],
                attribute_2: arry[2],
                attribute_20: arry[20],
                attribute_21: arry[21],
                attribute_3: arry[3],
                attribute_4: arry[4],
                attribute_5: arry[5],
                attribute_6: arry[6],
                attribute_7: arry[7],
                attribute_8: arry[8],
                attribute_9: arry[9],
                gajiPokok: arry[0],
                idPegawai: idPeg,
                pph21: arry[1],
                tipe: vals,
                unix: unix
            }
            DataApi.post("salary/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.loading = false
                this.currentAlertCounter = 7
                this.queryPegawaiAdd = ''
                this.idPegawaiAdd = ''
                this.addDetailPenghasilanTetap = ''
                this.addDetailPenghasilanTidakTetap = ''
                this.addDetailDitanggungPerusahaan = ''
                this.addDetailDitanggungPegawai = ''
                this.getData()
                this.moving()
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.editNama = generate.nama
            this.editNik = generate.nik
            this.editTglAktif = generate.tglAktif.split(" ")[0]
            this.editTglNonAktif = generate.tglNonAktif.split(" ")[0]
            this.editDetailPenghasilanTetap = generate.daftarPenghasilanTetap
            this.editDetailPenghasilanTidakTetap = generate.daftarPenghasilanTidakTetap
            this.editDetailDitanggungPerusahaan = generate.daftarDitanggungPerusahaan
            this.editDetailDitanggungPegawai = generate.daftarDitanggungPegawai
            this.editUnix = generate.unix
            this.editIdPeg = generate.idPegawai
            this.tipe = 'U'

            let data = this.editDetailPenghasilanTetap
            let data2 = this.editDetailPenghasilanTidakTetap
            let data3 = this.editDetailDitanggungPerusahaan
            let data4 = this.editDetailDitanggungPegawai
            var i,j,k,l = 0
            for(i=0;i<data.length;i++) {
                if(data[i].satuan == 'N') {
                    this.rupiahModeUangSaku('penghasilanTetap',i)
                }
            }
            for(j=0;j<data2.length;j++) {
                if(data2[j].satuan == 'N') {
                    this.rupiahModeUangSaku('penghasilanTidakTetap',j)
                }
            }
            for(k=0;k<data3.length;k++) {
                if(data3[k].satuan == 'N') {
                    this.rupiahModeUangSaku('penguranganDitanggungPerusahaan',k)
                }
            }
            for(l=0;l<data4.length;l++) {
                if(data4[l].satuan == 'N') {
                    this.rupiahModeUangSaku('penguranganDitanggungPegawai',l)
                }
            }
            this.moving()
        },
        viewData(value) {
            let generate = this.datas[value]
            this.viewNama = generate.nama
            this.viewNik = generate.nik
            this.viewDetailPenghasilanTetap = generate.daftarPenghasilanTetap
            this.viewDetailPenghasilanTidakTetap = generate.daftarPenghasilanTidakTetap
            this.viewDetailDitanggungPerusahaan = generate.daftarDitanggungPerusahaan
            this.viewDetailDitanggungPegawai = generate.daftarDitanggungPegawai
            this.viewTglAktif = generate.tglAktif
            this.viewTglNonAktif = generate.tglNonAktif
            this.viewUnix = generate.unix
            this.viewIdPeg = generate.idPegawai
            this.detailModal = true
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.tipe == 'U') {
                    this.goSave('U')
                }
            } else {
                if(this.tipe == 'U') {
                    this.goSave('U')
                } else {
                    this.goSave('C')
                }
                this.loading = true
            }
        },
        separatorInterval(val) {
            if(val == 'H') {
                return 'Hari'
            } else if(val == 'M') {
                return 'Minggu'
            } else {
                return 'Bulan'
            }
        },
        separatorRupiah(val) {
            let values = val.toString()
            let vals = ''
            let clear = ''
            if(values[0] == 'R') {
                clear = values.replace("Rp. ", '')
                var o
                for(o=0;o<clear.length;o++) {
                    if(clear[o] == '.') {
                        //
                    } else {
                        vals += clear[o]
                    }
                }
            } else {
                vals = values
            }
            let leng = vals.length
            let sisa 	= leng % 3
            let rupiah 	= vals.substr(0, sisa)
            let ribuan 	= vals.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return rupiah 
        },
        separatorSatuan(val) {
            if(val == 'N') {
                return 'Desimal'
            } else {
                return 'Persentase'
            }
        },
        rupiahModeUangSaku(param, id) {
            let number_string = ''
            if(param == 'penghasilanTetap') {
                number_string = this.editDetailPenghasilanTetap[id].nominal.toString().replace(/[^,\d]/g, '')
            } 
            if(param == 'penghasilanTidakTetap') {
                number_string = this.editDetailPenghasilanTidakTetap[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            if(param == 'penguranganDitanggungPerusahaan') {
                number_string = this.editDetailDitanggungPerusahaan[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            if(param == 'penguranganDitanggungPegawai') {
                number_string = this.editDetailDitanggungPegawai[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(param == 'penghasilanTetap') {
                this.editDetailPenghasilanTetap[id].nominal = hasil
            } 
            if(param == 'penghasilanTidakTetap') {
                this.editDetailPenghasilanTidakTetap[id].nominal = hasil
            }
            if(param == 'penguranganDitanggungPerusahaan') {
                this.editDetailDitanggungPerusahaan[id].nominal = hasil
            }
            if(param == 'penguranganDitanggungPegawai') {
                this.editDetailDitanggungPegawai[id].nominal = hasil
            }
        },
        separatorTanggal(val) {
            if(val == '') {
                return '-'
            } else {
                let date = val.split(" ")[0]
                let tahun = date.split("-")[0]
                let tanggal = date.split("-")[2]
                let bulan = ''
                let month = date.split("-")[1]
                if(month == '01') {
                    bulan = 'Jan'
                } else if(month == '02') {
                    bulan = 'Feb'
                } else if(month == '03') {
                    bulan = 'Mar'
                } else if(month == '04') {
                    bulan = 'Apr'
                } else if(month == '05') {
                    bulan = 'Mei'
                } else if(month == '06') {
                    bulan = 'Jun'
                } else if(month == '07') {
                    bulan = 'Jul'
                } else if(month == '08') {
                    bulan = 'Agu'
                } else if(month == '09') {
                    bulan = 'Sep'
                } else if(month == '10') {
                    bulan = 'Okt'
                } else if(month == '11') {
                    bulan = 'Nov'
                } else if(month == '12') {
                    bulan = 'Des'
                }

                return tanggal + ' ' + bulan + ' ' + tahun
            }
        },

        separatorIntervalAdd(val) {
            if(val == 'H') {
                return 'Hari'
            } else if(val == 'M') {
                return 'Minggu'
            } else {
                return 'Bulan'
            }
        },
        separatorSatuanAdd(val) {
            if(val == 'N') {
                return 'Desimal'
            } else {
                return 'Persentase'
            }
        },
        rupiahModeUangSakuAdd(param, id) {
            let number_string = ''
            if(param == 'penghasilanTetap') {
                number_string = this.addDetailPenghasilanTetap[id].nominal.toString().replace(/[^,\d]/g, '')
            } 
            if(param == 'penghasilanTidakTetap') {
                number_string = this.addDetailPenghasilanTidakTetap[id].nominal.toString().replace(/[^,\d]/g, '')
            } 
            if(param == 'penguranganDitanggungPerusahaan') {
                number_string = this.addDetailDitanggungPerusahaan[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            if(param == 'penguranganDitanggungPegawai') {
                number_string = this.addDetailDitanggungPegawai[id].nominal.toString().replace(/[^,\d]/g, '')
            }
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(param == 'penghasilanTetap') {
                this.addDetailPenghasilanTetap[id].nominal = hasil
            } 
            if(param == 'penghasilanTidakTetap') {
                this.addDetailPenghasilanTidakTetap[id].nominal = hasil
            } 
            if(param == 'penguranganDitanggungPerusahaan') {
                this.addDetailDitanggungPerusahaan[id].nominal = hasil
            }
            if(param == 'penguranganDitanggungPegawai') {
                this.addDetailDitanggungPegawai[id].nominal = hasil
            }
        },

        loadFile() {
            this.loadingUpload = true
            let nama = document.getElementById('inputFile').files[0]

            this.dataImport = []
            this.filesImport = document.getElementById('inputFile').files[0];

            const formData = new FormData();
            formData.append("file", this.filesImport)
            DataApi.post("import/salary/preview", formData)
            .then(res => {
                let temp = res.data
                if(temp.success == true) {
                    this.dataImport = temp.data
                    this.jumlahInvalid = temp.data.jumlahInvalid
                    this.jumlahValid = temp.data.jumlahValid
                    this.infoImport = nama.name
                } else {
                    this.dataImport = []
                    this.jumlahInvalid = ''
                    this.jumlahValid = ''
                    this.alertMessImport = temp.message
                    this.currentAlertCounterImport = 7
                    this.successImport = false
                    window.scroll({
                        top:0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
                this.loadingUpload = false
            })
        },
        sumbitImport() {
            this.loadingImport = true
            let payload = this.dataImport.data
            DataApi.post("import/salary", payload )
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.loadingImport = false
                this.dataImport = []
                this.infoImport = ''
                this.goArea = '1'
                this.jumlahInvalid = ''
                this.jumlahValid = ''
                this.currentAlertCounter = 7
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-cancel {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
</style>